<template>
    
    <div class="cursor-music">
        <audio @canplaythrough="(e) => e.target.volume = '0.5'" :src="(music.track || music.original_sound).progressive_download_url" :ref="`music-preview`"></audio>
        <div class="options">
            <div class="circle btn-time">

                <select v-if="durationLock" class="timer-music" disabled>
                    <option selected>{{ parseInt(this.models.rangeDuration/1000) }}</option>
                </select>

                <select v-else class="timer-music" v-model="models.rangeDuration" @change="playMusic">
                    <option disabled>Secondes</option>
                    <option v-for="value in Array.from({ length: Math.max(0, maxDurationSec - 4) }, (_, i) => i + 5)" :value="value * 1000" :key="value">{{ value }}</option>
                </select>
            </div>
            <div class="container-line" @click.stop="clickLine">
                <div class="repair" :style="{left : `${time / (music.track || musics.original_sound).duration_in_ms * 100}%`}" v-for="time in (music.track ? music.track.highlight_start_times_in_ms : [])" @click.stop="clickRepair(time)"></div>
                <div class="range" :style="{
                    width : `${parseInt(rangeDuration) / (music.track || musics.original_sound).duration_in_ms * 100}%`,
                    left : `${models.start / (music.track || music.original_sound).duration_in_ms * 100}%`
                }" 
                @click.stop
                ></div>
            </div>
            <div class="circle btn-play" :class="{playing: isPlaying}" @click="toggleMusic"></div>
        </div>
        <div class="timeline">
            <div class="box"><div class="progress" :style="isPlaying && duration >= 0 ? `width: ${100 - (duration / parseInt(rangeDuration) * 100)}%;`: ''"></div></div>
            <div 
                class="bars hide-scrollbar" 
                @mousedown="startDrag" 
                @mousemove="onDrag" 
                @mouseup="stopDrag" 
                @mouseleave="stopDrag" 
                @scroll="handleScroll" 
                
                ref="scrollContainer"
            >
                    
                <div class="bar" :class="{high: index%2 == 0}" v-for="(bar, index) in Array.from({length: parseInt((music.track || musics.original_sound).duration_in_ms / 1000)})"></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        music: Object,
        durationLock: Number,
        defaultRangeDuration: {
            type: String | Number,
            default: 15000,
        },
        defaultStart: {
            type: Number,
            default: 0,
        },
        videoDurationMs: {
            type: Number,
            default: 0,
        },
    },

    mounted () {
        this.clickRepair(this.models.start);
    },

    data() {
        return {
            models : {
                rangeDuration: String(this.defaultRangeDuration),
                start: this.defaultStart,
            },
            isPlaying: false,
            timeOutRepeatRange: null,
            intervalRange: null,
            duration: 0,
            isDragging: false, // Indique si l'utilisateur est en train de faire glisser
            startX: 0, // Position initiale de la souris
            scrollLeft: 0, // Position initiale du défilement
        }
    },

    methods: {

        playMusic() {
            if (this.timeOutRepeatRange) clearTimeout(this.timeOutRepeatRange)
            if (this.intervalRange) clearInterval(this.intervalRange)
            this.duration = 0


            let audio = this.$refs['music-preview'];
            if (document.contains(audio)) {
                this.isPlaying = true
                audio.currentTime = this.models.start / 1000;
                audio.play();

                this.timeOutRepeatRange = setTimeout(() => {
                    if (this.intervalRange) clearInterval(this.intervalRange)
                    this.playMusic()
                }, this.rangeDuration);

                this.intervalRange = setInterval(()=> {
                    this.duration = this.duration + 100
                },100)
            }
            
        },

        pauseMusic() {
            this.duration = 0
            if (this.timeOutRepeatRange) clearTimeout(this.timeOutRepeatRange)
            if (this.intervalRange) clearInterval(this.intervalRange)

            let audio = this.$refs['music-preview']
            audio.pause();
        },

        toggleMusic() {
            let audio = this.$refs['music-preview'];
            this.isPlaying = audio.paused
            if (audio.paused) {
                this.playMusic()
            } else {
                if (this.timeOutRepeatRange) clearTimeout(this.timeOutRepeatRange)
                if (this.intervalRange) clearInterval(this.intervalRange)
                audio.pause();
            }
        },

        clickLine(e) {
            const divWidth = e.currentTarget.offsetWidth;
            const clickX = e.offsetX;
            const percentage = (clickX / divWidth);
            const timeMs = Math.round((this.music.track || this.music.original_sound).duration_in_ms * percentage);
            this.models.start = timeMs

            const scrollPercentage = timeMs / ((this.music.track || this.music.original_sound).duration_in_ms - parseInt(this.rangeDuration))
            this.$refs.scrollContainer.scrollLeft = (this.$refs.scrollContainer.scrollWidth - this.$refs.scrollContainer.clientWidth) * scrollPercentage;
            console.log(`Position horizontale : ${percentage}%`);
        },

        clickRepair(timeMs) {
            this.models.start = timeMs;
            const scrollPercentage = timeMs / ((this.music.track || this.music.original_sound).duration_in_ms - parseInt(this.rangeDuration))
            this.$refs.scrollContainer.scrollLeft = (this.$refs.scrollContainer.scrollWidth - this.$refs.scrollContainer.clientWidth) * scrollPercentage;
            this.playMusic()
        },

        startDrag(e) {
            this.isDragging = true;
            this.startX = e.pageX - this.$refs.scrollContainer.offsetLeft; // Position de la souris relative à l'élément
            this.scrollLeft = this.$refs.scrollContainer.scrollLeft; // Position actuelle du défilement
        },

        onDrag(e) {
            if (!this.isDragging) return; // Ne rien faire si l'utilisateur ne fait pas glisser
            e.preventDefault(); // Empêche la sélection de texte pendant le glissement
            const x = e.pageX - this.$refs.scrollContainer.offsetLeft; // Position actuelle de la souris
            const walk = (x - this.startX) * 1; // Distance parcourue par la souris (facteur de vitesse ajustable)
            this.$refs.scrollContainer.scrollLeft = this.scrollLeft - walk; // Ajuste la position de défilement
        },

        stopDrag() {
            this.isDragging = false; // Arrête le glissement
        },

        handleScroll(event) {
            const element = event.target; 
            const scrollPercentage = (element.scrollLeft / (element.scrollWidth - element.clientWidth))
            this.models.start = Math.round((this.music.track || this.music.original_sound).duration_in_ms * scrollPercentage - parseInt(this.rangeDuration) * scrollPercentage)
            this.playMusic()
        },
    },

    computed: {
        rangeDuration() {
            return this.models.rangeDuration
        },
        maxDurationSec() {
            const track = this.music && (this.music.track || this.music.original_sound)
            const musicMs = track && track.duration_in_ms ? track.duration_in_ms : 180000
            const videoMs = this.videoDurationMs && this.videoDurationMs > 0 ? this.videoDurationMs : Infinity
            return Math.max(5, Math.floor(Math.min(musicMs, videoMs) / 1000))
        }
    },

    watch: {
        'models.rangeDuration': {
            immediate: true,
            handler(newValue, oldValue) {
                this.$emit('rangeDurationChange', newValue)
            }
        },
        'models.start': {
            immediate: true,
            handler(newValue, oldValue) {
                this.$emit('startChange', newValue)
            }
        },
        'durationLock': {
            immediate: true,
            handler(newValue, oldValue) {
                if (this.durationLock) {
                    this.models.rangeDuration = Math.min(newValue, (this.music.track || this.musics.original_sound).duration_in_ms)
                }
            }
        },
        maxDurationSec: {
            immediate: true,
            handler(newMax) {
                const currentSec = parseInt(this.models.rangeDuration) / 1000
                if (currentSec > newMax) {
                    this.models.rangeDuration = newMax * 1000
                }
            }
        }
    },
       beforeDestroy() {
        const audio = this.$refs['music-preview']
        if (audio) {
            audio.pause()
            audio.removeAttribute('src')
            audio.load()
        }
    },
       destroyed () {
        if (this.timeOutRepeatRange) clearTimeout(this.timeOutRepeatRange)
        if (this.intervalRange) clearInterval(this.intervalRange)
    },
}
</script>

<style lang="scss" scoped>
    .cursor-music {
        width: 100%;
        .options {
            display: flex;
            align-items: center;

            // padding: 0 32px;
            padding: 0 2em;
            // gap: 20px;
            gap: 1.25em;
            // margin-bottom: 15px;
            margin-bottom: 0.9375em;

            .circle {
                
                border-radius: 50%;
                display: flex;
                justify-content: center;
                align-items: center;
                cursor: pointer;
                // border: 1.5px solid #fff;
                border: 0.09375em solid #fff;
                
                &.btn-time {
                    // height: 28px;
                    height: 1.75em;
                    // width: 28px;
                    width: 1.75em;
                    
                    select,input {
                        all: unset;
                        width: 100%;
                        height: 100%;
                        color: #fff;
                        text-align: center;
                        font-weight: 500;
                        // font-size: 11px;
                        font-size: 0.6875em;
                        line-height: 2.31em;
                    }
                }
                
                &.btn-play {
                    background-color: #fff;
                    // height: 26px;
                    height: 1.625em;
                    // width: 26px;
                    width: 1.625em;

                    &:before {
                        content: "\f04b";
                        font-family: "Font Awesome 7 Pro" !important;
                        font-weight: 900;
                        color: #fff;
                        color: #272727;
                        // font-size: 9px;
                        font-size: 0.5625em;
                        // transform: translateX(1px);
                        transform: translateX(0.1111111111111111em);
                    }
                    
                    &.playing:before {
                        content: "\f0c8";
                        font-family: "Font Awesome 7 Pro" !important;
                        font-weight: 900;
                        color: #fff;
                        color: #272727;
                        transform: translateX(0px);
                        // font-size: 9px;
                        font-size: 0.5625em;
                    }
                }
            }
            
            .container-line {
                width: 0;
                flex-grow: 1;   
                background-color: #ffffff77;
                position: relative;
                cursor: pointer;
                // height: 3px;
                height: 0.1875em;
                // border-radius: 1px;
                border-radius: 0.0625em;

            

                .repair {
                    border-radius: 50%;
                    background-color: #ff0066;
                    position: absolute;
                    top: 50%;
                    left: 0%;
                    transform: translate(-50%, -50%);
                    cursor: pointer;

                    // height: 6px;
                    height: 0.375em;
                    // width: 6px;
                    width: 0.375em;
                }
                
                .range {
                    background-color: #fff;  
                    position: absolute;
                    top: 50%;
                    left: 0;
                    transform: translateY(-50%);
                    cursor: pointer;

                    // height: 4px
                    height: 0.25em;
                    // border-radius: 1.5px;
                    border-radius: 0.09375em;
                }
            } 
        }
        
        .timeline {
            position: relative;
            // margin-bottom: 20px;
            margin-bottom: 1.25em;
            
            .bars {
                display: flex;
                align-items: center;
                overflow-x: auto;
                padding: 0 33.3%;
                position: relative;
                z-index: 1;
                cursor: pointer !important;

                // height: 45px;
                height: 2.8125em;
                // gap: 4px;
                gap: 0.25em;
        
                .bar {
                    background-color: #e6eaee;
                    cursor: pointer !important;
                    // height: 10px;
                    height: 0.625em;
                    // width: 3.5px;
                    width: 0.21875em;
                    // min-width: 3.5px;
                    min-width: 0.21875em;
                    // border-radius: 2px;
                    border-radius: 0.125em;
            
                    &.high {
                        // height: 16px;
                        height: 1em;
                    }
                }
            }
            
            .box {
                position: absolute;
                top: 0;
                left: 33%;
                content: '';
                display: block;
                height: 100%;
                width: 34%;
                box-sizing: border-box !important;
                background-color: #fff;
                z-index: 0;
                background: rgb(178,75,247);
                background: linear-gradient(345deg, rgba(178,75,247,1) 0%, rgba(244,31,252,1) 17%, rgba(253,29,29,1) 57%, rgba(248,190,35,1) 100%); 
                background-position-x: -100%;

                // border: 3px #e6eaee solid;
                border: 0.1875em #e6eaee solid;
                // border-radius: 5px;
                border-radius: 0.3125em;
                
                .progress {
                    height: 100%;
                    position: absolute;
                    right: 0;
                    background-color: #fff;
                    width: 100%;
                }
            }
        }
    }
</style>